<template>
  <paginated-list
    :actions="actions"
    :columns="columns"
    :query="query"
    service="assetStatements">
    <template v-slot:top>
      <p>
        Please provide true and accurate information regarding your assets and liabilities to help us to complete our credit assessment.
        From the information provided, we require information on the following individuals but may require additional information as part
        of any application or at any stage in the future.
      </p>
    </template>
  </paginated-list>
</template>

<script>
import PaginatedList from './PaginatedList.vue'

export default {
  created () {
    if (!this.$auth.admin()) {
      this.query.user = this.$auth.user._id
    }
  },

  data () {
    return {
      query: {}
    }
  },

  name: 'AssetStatementFilter',

  components: {
    PaginatedList
  },

  computed: {
    actions () {
      return [{
        text: 'Complete',
        to: {
          name: 'asset-statements.edit'
        },
        showIf: ({ completed }) => completed !== true
      }, {
        text: 'View',
        to: {
          name: 'asset-statements.view'
        },
        showIf: ({ completed }) => completed === true
      }, {
        text: 'Review',
        to: {
          name: 'asset-statements.review'
        },
        showIf: ({ completed }) => completed === true
      }]
    },

    columns () {
      return {
        'profile.name': {
          header: 'Name',
          format: ({ profile }) => `${profile.firstName} ${profile.lastName}`
        },
        'profile.address.postcode': 'Post Code',
        'profile.dob': 'Date of Birth',
        completedAt: {
          header: 'Date Completed',
          format: ({ completedAt }) => this.$dates.toDateTime(completedAt)
        },
        approvedAt: {
          header: 'Date Approved',
          format: ({ approvedAt }) => this.$dates.toDateTime(approvedAt)
        }
      }
    }
  }
}
</script>
